import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ItemPriceComponent, ItemStockButtonComponent } from '../../../common';
import { ItemResultLayoutComponentsProviderComponentBase, RenderInItemResultLayoutDirective } from '../../../layouts';
import { ProductNotReturnableComponent } from '../../../../product';

@Component({
  selector: 'ideal-common-item-result-layout-components-provider',
  imports: [RenderInItemResultLayoutDirective, ItemStockButtonComponent, ItemPriceComponent, ProductNotReturnableComponent],
  standalone: true,
  templateUrl: './common-item-result-layout-components-provider.component.html',
  styleUrl: './common-item-result-layout-components-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonItemResultLayoutComponentsProviderComponent extends ItemResultLayoutComponentsProviderComponentBase {}
